<template>
  <swiper
    :breakpoints="breakpoint"
    :loop="true"
    :loopFillGroupWithBlank="true"
    :speed="800"
    :autoplay='{
  "delay": 3000,
  "disableOnInteraction": false
}' 
    :pagination="{
      clickable: true,
    }"
    :navigation="true"
    class="mySwiper"
  >
    <swiper-slide v-for="data in datas" :key="data">
      <slot :slidercontent="data"> </slot>
    </swiper-slide>
  </swiper>
</template>
<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

import "swiper/swiper-bundle.css";

import SwiperCore, { Pagination, Navigation,Autoplay } from "swiper";
// import Card from './Card.vue';

// install Swiper modules
SwiperCore.use([Pagination, Navigation,Autoplay]);

export default {
  props: ["breakpoint", "datas"],
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
